<form [formGroup]="form" class="container-fluid container-filter" autocomplete="off">

    <div class="animated fadeIn">

        <div class="row">
            <div class="col-md-12">
                <h4>Buscador de Alertas de Matrículas Rechazadas - Importación</h4>

                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed"
                       aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Filtros
                            <i *ngIf="isCollapsed" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsed" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body">

                        <div class="collapse group-filtros" id="collapseFiltros" [ngbCollapse]="isCollapsed">

                            <div class="row">

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="intEspecie">Código</label>
                                    <input formControlName="Codigo" name="Codigo" class="form-control" inputStyleClass="form-control" type="text" value="" maxlength="50">
                                </div>

                                <div class="form-group col-md-4">
                                    <label for="time" class="col-form-label" for="inpFechaEnvio">Fecha de envío</label>
                                    <p-calendar formControlName="FechaEnvio" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy" appendTo="body"></p-calendar>
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="intMatricula">Matrícula</label>
                                    <input formControlName="Matricula" name="Matricula" class="form-control" inputStyleClass="form-control" type="text" value="" maxlength="50">
                                </div>

                            </div>

                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group-0 float-right">

                                    <div class="btn-group">
                                        <button [disabled]="disableSearchBtn" name="btnSearch" class="btn btn-secondary btn-sm" type="submit"
                                                title="Realiza una búsqueda" (click)="onSearch($event)">
                                            <i class="fa fa-search"></i> Buscar
                                        </button>
                                    </div>

                                    <div class="btn-group">
                                        <button class="btn btn-secondary btn-sm" type="button"
                                                title="Limpia los filtros" (click)="resetForm($event)">
                                            <i class="fa fa-eraser"></i> Limpiar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

</form>
